import React from "react";
import styled from "styled-components";

interface Props {
  src: string;
  alt: string;
  width?: string;
  height?: string;
  style?: any;
}
const Image: React.FC<Props> = ({ src, width, height, alt, style }) => {
  return (
    <StyledImage
      src={src}
      width={width}
      height={height}
      alt={alt}
      style={style}
    />
  );
};
export default Image;
const StyledImage = styled.img<Props>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "100%"};
`;
